<template>
  <div class="container-box">
    <MediaHeader />

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="showModal = true"
        >
          <v-icon left> mdi-plus </v-icon>
          코스 등록
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ customBoardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.create_at`]="{ item }">
          {{ item.create_at | moment('YYYY.MM.DD HH:mm:ss') }}
        </template>

        <template v-slot:[`item.is_valid`]="{ item }">
          <v-switch
            inset
            hide-details
            color="#fecd00"
            :input-value="item.is_valid === 'Y' ? true : false"
            :label="item.is_valid === 'Y' ? 'ON' : 'OFF'"
            class="switch-type-1 mt-0"
            @change="isValidPopup(item)"
          ></v-switch>
        </template>

        <template v-slot:[`item.modify`]="{ item }">
          <a
            href=""
            @click.prevent="modifyModal(item)"
            style="color: transparent"
          >
            <v-icon color="#fecd00">mdi-cog-outline</v-icon>
          </a>
        </template>

        <template v-slot:no-data>
          <div class="text-center">
            등록된 코스가 없습니다. 우측상단 코스등록 버튼을 클릭후 코스를
            추가해주세요.
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>

    <!-- Modal -->
    <v-dialog
      persistent
      v-model="showModal"
      width="464"
      content-class="popup-wrap-1"
    >
      <div class="pa-9">
        <p class="title-type-4">코스 관리</p>
        <v-form ref="form">
          <div class="form-row-1">
            <p class="label">
              CC_ID
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내로 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalCourse.cc_id"
                :rules="ccIDrules"
                solo
              ></v-text-field>
            </div>
          </div>

          <div class="form-row-1 mt-6">
            <p class="label">
              코스명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내로 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalCourse.name"
                :rules="courseNameRules"
                solo
              ></v-text-field>
            </div>
          </div>

          <div class="form-row-1 mt-6">
            <p class="label">노출 관리</p>
            <div class="write-con">
              <v-radio-group v-model="modalCourse.is_valid" class="mt-0" row>
                <v-radio
                  label="ON"
                  value="Y"
                  color="#fecd00"
                  class="radio-type-1"
                ></v-radio>
                <v-radio
                  label="OFF"
                  value="N"
                  color="#fecd00"
                  class="radio-type-1 ml-2"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-form>

        <div class="d-flex justify-end mt-6">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-2"
            @click.stop="modalCancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click.prevent="registerCourse"
            :disabled="
              !modalCourse.cc_id || !modalCourse.name || !modalCourse.is_valid
            "
          >
            저장
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- Modal -->

    <SystemAlert v-model="showSystemAlert" :persistent="true">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import { listCourse, createCourse, updateCourse } from '@/api/courses';

import SystemAlert from '~@/modal/SystemAlert';
import MediaHeader from '@/views/media/header';

export default {
  components: { MediaHeader, SystemAlert },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: 'No', value: 'no', width: '8%', sortable: false },
      { text: 'CC_ID', value: 'cc_id', sortable: false },
      { text: '코스명', value: 'name', width: '20%', sortable: false },
      { text: '등록일', value: 'create_at', width: '14%', sortable: false },
      {
        text: '등록 관리자',
        value: 'creator.manager_name',
        width: '18%',
        sortable: false,
      },
      { text: '노출관리', value: 'is_valid', width: '18%', sortable: false },
      { text: '관리', value: 'modify', width: '8%', sortable: false },
    ],
    boardLists: [],
    modalCourse: null,
    modifyCourse: null,
    ccIDrules: [
      v => !!v || '필수 항목 입니다!',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    courseNameRules: [
      v => !!v || '코스명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글, 영문, 숫자만 입력 가능합니다.',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    resultType: '',
    logResult: '',
    showModal: false,
    showSystemAlert: false,
  }),
  computed: {
    customBoardLists() {
      this.boardLists.forEach((item, index) => {
        item.no = this.boardLists.length - index;
        item.modify = '수정';
      });
      return this.boardLists;
    },
    clearModalCourse() {
      return {
        name: '',
        cc_id: '',
        is_valid: false,
      };
    },
  },
  methods: {
    async getListCourse() {
      try {
        const { data } = await listCourse();
        this.boardLists = data.list.reverse();
      } finally {
        bus.$emit('end:spinner');
      }
    },
    async registerCourse() {
      bus.$emit('start:spinner');
      try {
        const courseData = {
          cc_id: this.modalCourse.cc_id.trim(),
          name: this.modalCourse.name.trim(),
          is_valid: this.modalCourse.is_valid,
        };
        const { data } = this.modifyCourse
          ? await updateCourse(this.modifyCourse.id, courseData)
          : await createCourse(courseData);

        if (data.result === 'success') {
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = `코스가 ${
            this.modifyCourse ? '수정' : '등록'
          } 되었습니다.`;
          this.$refs.form.reset();
          this.modifyCourse = null;
        }
      } catch (error) {
        const { data } = error.response;
        this.resultType = data.result;
        this.$refs.form.reset();
        this.modalCourse = null;

        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      } finally {
        bus.$emit('end:spinner');
      }
    },
    async closePopup() {
      this.showSystemAlert = false;
      if (this.resultType === 'success') {
        bus.$emit('start:spinner');
        this.showModal = false;

        await this.getListCourse();
      }
    },
    modifyModal(item) {
      this.modifyCourse = item;
      this.modalCourse = Object.assign({}, item);
      this.showModal = true;
    },
    async isValidPopup(item) {
      this.modalCourse = item;

      bus.$emit('start:spinner');
      try {
        const courseData = {
          cc_id: item.cc_id.trim(),
          name: item.name.trim(),
          is_valid: item.is_valid === 'Y' ? 'N' : 'Y',
        };
        const { data } = await updateCourse(item.id, courseData);
        if (data.result === 'success') {
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '노출 설정을 변경하였습니다.';
          this.modifyCourse = null;
        }
      } catch (error) {
        const { data } = error.response;
        this.resultType = data.result;
        this.modifyCourse = null;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      } finally {
        bus.$emit('end:spinner');
      }
    },
    modalCancel() {
      this.$refs.form.reset();

      this.modalCourse = this.clearModalCourse;
      this.modifyCourse = null;
      this.showModal = false;
    },
  },
  async created() {
    bus.$emit('start:spinner');

    this.modalCourse = this.clearModalCourse;
    await this.getListCourse();
  },
};
</script>
